__turbopack_context__.v({
  "errorMessage": "Fieldset-module__QSWeQa__errorMessage",
  "fieldContainer": "Fieldset-module__QSWeQa__fieldContainer",
  "fieldset": "Fieldset-module__QSWeQa__fieldset",
  "groupError": "Fieldset-module__QSWeQa__groupError",
  "groupHint": "Fieldset-module__QSWeQa__groupHint",
  "groupLabel": "Fieldset-module__QSWeQa__groupLabel",
  "invisibleLegend": "Fieldset-module__QSWeQa__invisibleLegend",
  "legend": "Fieldset-module__QSWeQa__legend",
  "legendMedium": "Fieldset-module__QSWeQa__legendMedium",
});
